import { get, set } from 'lib/storage/versionedLocalStorageUtils'
import moment, { type Moment } from 'moment'

export interface ExpiringDismissalEntry {
  endDate: string
}

export type ExpiringDismissalsMap = Record<string, ExpiringDismissalEntry>

export function loadExpiringDismissalsMap(storageKey: string, version: number): ExpiringDismissalsMap {
  return get<ExpiringDismissalsMap>(storageKey, version) ?? {}
}

export function saveExpiringDismissalsMap(storageKey: string, version: number, map: ExpiringDismissalsMap) {
  set(storageKey, version, map)
}

/** Site banner dismissal cleanup: drop entries expired by more than one day. */
export function pruneDismissalsStaleAfterOneDay(dismissals: ExpiringDismissalsMap, now: Moment) {
  Object.keys(dismissals).forEach(id => {
    const expiry = moment(dismissals[id].endDate)
    if (now.diff(expiry, 'days') > 1) {
      delete dismissals[id]
    }
  })
}

/** Modal (and similar) cleanup: drop entries strictly past expiry. */
export function pruneDismissalsPastExpiry(dismissals: ExpiringDismissalsMap, now: Moment) {
  Object.keys(dismissals).forEach(id => {
    if (now.isAfter(moment(dismissals[id].endDate))) {
      delete dismissals[id]
    }
  })
}
